/** PostHog group type - must match server `POSTHOG_ENVELOPE_GROUP`. */
export const POSTHOG_ENVELOPE_GROUP = "envelope" as const;

export const PIECE_CID_PROPERTY = "piece_cid" as const;
